// src/constants.js
export const BASE_SUB_PATH = "/patient";

/**
 * BUILD_ENV is set at build time (e.g. BUILD_ENV=staging or BUILD_ENV=production).
 * We also accept REACT_APP_BUILD_ENV to follow CRA conventions.
 *
 * IMPORTANT: Do NOT use window/self for env detection here — this module is
 * bundled into both the main app and the SW at build time.
 */
const BUILD_ENV =
  (typeof process !== "undefined" &&
    (process.env.BUILD_ENV || process.env.REACT_APP_BUILD_ENV)) ||
  "staging";

const FCM_STAGING_CONFIG = {
  apiKey: "AIzaSyCiS2ZXJHWaE4UsEwoBzf-H8yPqLSKJfA8",
  authDomain: "ic4-fcm-staging.firebaseapp.com",
  projectId: "ic4-fcm-staging",
  storageBucket: "ic4-fcm-staging.firebasestorage.app",
  messagingSenderId: "297953808050",
  appId: "1:297953808050:web:7708f895ff6fbdc093c3ab",
};

const FCM_PROD_CONFIG = {
  apiKey: "AIzaSyCwXJF7b2wQnlOjoyNRJmjeRDOh-ON_TOU",
  authDomain: "ic4-fcm.firebaseapp.com",
  projectId: "ic4-fcm",
  storageBucket: "ic4-fcm.firebasestorage.app",
  messagingSenderId: "268249369791",
  appId: "1:268249369791:web:5483f57557997c951eca0a",
  measurementId: "G-5JRT4ZT34Y",
};

const env = String(BUILD_ENV).toLowerCase();

export const FCM_CONFIG =
  env === "staging" || env === "dev" ? FCM_STAGING_CONFIG : FCM_PROD_CONFIG;
